export default __webpack_public_path__ + "static/media/mirror.815e18a0.png";